// extracted by mini-css-extract-plugin
export var hasMarginStyle = "wrapper-module--hasMarginStyle--CvehW";
export var hasPaddingStyle = "wrapper-module--hasPaddingStyle--ZHNDX";
export var wrapperStyle = "wrapper-module--wrapperStyle--kne2K";